import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormat } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'

export const Columns = (
  onClick: (text: string, t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    // {
    //   title: '门店名称',
    //   dataIndex: 'local',
    //   align: 'center',
    //   width: '8rem',
    //   ellipsis: true,
    //   render: (_, t) => {
    //     return t.local ? t.local : '-'
    //   },
    // },
    {
      title: '培训流水',
      dataIndex: 'id',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.id ? t.id : '-'
      },
    },
    {
      title: '培训类别',
      dataIndex: 'trainingCategory',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.trainingCategory ? t.trainingCategory : '-'
      },
    },
    {
      title: '培训地点',
      dataIndex: 'trainingLocation',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.trainingLocation ? t.trainingLocation  : '-'
      },
    },
    {
      title: '主办单位',
      dataIndex: 'sponsorUnit',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.sponsorUnit ? t.sponsorUnit : '-'
      },
    },
    {
      title: '讲课人',
      dataIndex: 'lecturer',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.lecturer
          ? t.lecturer 
          : '-'
      },
    },
    {
      title: '证书名称',
      dataIndex: 'certificateName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.certificateName ? t.certificateName  : '-'
      },
    },
    {
      title: '证书编号',
      dataIndex: 'certificateNumber',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.certificateNumber ? t?.certificateNumber : '-'
      },
    },
    {
      title: '开始时间',
      dataIndex: 'startTime',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.startTime ? moment(t.startTime).format(DateTimeFormat) : '-'
      },
    },
    {
      title: '结束时间',
      dataIndex: 'endTime',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.endTime ? moment(t.endTime).format(DateTimeFormat) : '-'
      },
    },
    {
      title: '学时',
      dataIndex: 'classHours',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.classHours > 0 ? t?.classHours : '-'
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.remark ? t?.remark : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '10rem',
      render: function Element(_, t) {
        return (
          <>
           <Button
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              onClick={() => {
                onClick('detail', t)
              }}
            >
             查看明细
            </Button>
          </>
        )
      },
    },
  ]
}



export const DetailColumns = (
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '培训对象',
      dataIndex: 'trainingObject',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.trainingObject ? t.trainingObject : '-'
      },
    },
    {
      title: '考核得分',
      dataIndex: 'assessmentScore',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.assessmentScore ? t.assessmentScore : '-'
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.remark ? t.remark : '-'
      },
    },
  ]
}
